import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pagination--next",
  "use": "icon-pagination--next-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\" id=\"icon-pagination--next\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m14.617 12.231-3.45 3.224.636.776 3.866-3.611a.532.532 0 0 0 .165-.389c0-.148-.06-.29-.165-.388l-3.866-3.612-.636.777 3.45 3.223Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol